import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }

import { computed } from 'vue';
    import BulkStatusSelect from '@/components/dashboard/BulkStatusSelect.vue';
    import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
    import type { Column, Table } from '@tanstack/vue-table';
    import type { SelectOption } from '@/types';

    interface DataTableColumnHeaderWithBulkProps {
        column: Column<any, any>;
        table: Table<any>;
        title: string;
        statusOptions?: SelectOption[];
        dataFieldGroup?: string;
        reportingPeriod?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableColumnHeaderWithBulk',
  props: {
    column: {},
    table: {},
    title: {},
    statusOptions: {},
    dataFieldGroup: {},
    reportingPeriod: {}
  },
  setup(__props: any) {

    const props = __props;

    const hasSelectedRows = computed(() => {
        return props.table.getFilteredSelectedRowModel().flatRows.length > 0;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.statusOptions && _ctx.dataFieldGroup && _ctx.reportingPeriod && hasSelectedRows.value)
      ? (_openBlock(), _createBlock(BulkStatusSelect, {
          key: 0,
          table: _ctx.table,
          options: _ctx.statusOptions,
          "data-field-group": _ctx.dataFieldGroup,
          "reporting-period": _ctx.reportingPeriod,
          title: _ctx.title
        }, null, 8, ["table", "options", "data-field-group", "reporting-period", "title"]))
      : (_openBlock(), _createBlock(DataTableColumnHeader, {
          key: 1,
          column: _ctx.column,
          title: _ctx.title
        }, null, 8, ["column", "title"]))
  ]))
}
}

})